/* eslint-disable */
// Auto-generated by generate_constants.py. Do not edit manually.

export const LAYOUT_GROUPS = [
  { id: "3-7", label: "Tầng 3-7" },
  { id: "8-12A", label: "Tầng 8-12A" },
  { id: "14-21", label: "Tầng 14-21" },
  { id: "22", label: "Tầng 22" },
];

export const FLOORS_CONFIG = [
  {
    "id": "3",
    "label": "Tầng 3",
    "layoutGroup": "3-7"
  },
  {
    "id": "3A",
    "label": "Tầng 3A",
    "layoutGroup": "3-7"
  },
  {
    "id": "5",
    "label": "Tầng 5",
    "layoutGroup": "3-7"
  },
  {
    "id": "6",
    "label": "Tầng 6",
    "layoutGroup": "3-7"
  },
  {
    "id": "7",
    "label": "Tầng 7",
    "layoutGroup": "3-7"
  },
  {
    "id": "8",
    "label": "Tầng 8",
    "layoutGroup": "8-12A"
  },
  {
    "id": "9",
    "label": "Tầng 9",
    "layoutGroup": "8-12A"
  },
  {
    "id": "10",
    "label": "Tầng 10",
    "layoutGroup": "8-12A"
  },
  {
    "id": "11",
    "label": "Tầng 11",
    "layoutGroup": "8-12A"
  },
  {
    "id": "12",
    "label": "Tầng 12",
    "layoutGroup": "8-12A"
  },
  {
    "id": "12A",
    "label": "Tầng 12A",
    "layoutGroup": "8-12A"
  },
  {
    "id": "14",
    "label": "Tầng 14",
    "layoutGroup": "14-21"
  },
  {
    "id": "15",
    "label": "Tầng 15",
    "layoutGroup": "14-21"
  },
  {
    "id": "16",
    "label": "Tầng 16",
    "layoutGroup": "14-21"
  },
  {
    "id": "17",
    "label": "Tầng 17",
    "layoutGroup": "14-21"
  },
  {
    "id": "18",
    "label": "Tầng 18",
    "layoutGroup": "14-21"
  },
  {
    "id": "19",
    "label": "Tầng 19",
    "layoutGroup": "14-21"
  },
  {
    "id": "20",
    "label": "Tầng 20",
    "layoutGroup": "14-21"
  },
  {
    "id": "21",
    "label": "Tầng 21",
    "layoutGroup": "14-21"
  },
  {
    "id": "22",
    "label": "Tầng 22",
    "layoutGroup": "22"
  }
];
